export const ARTICLE_CONTENT_UPDATE_DELAY = 200
export const ARTICLE_SAVE_DELAY = ARTICLE_CONTENT_UPDATE_DELAY + 10
export const KNOWLEDGE_BASE_PATH = "knowledge-base"
